import Action, { ActionServices, ActionServicesFetchError, ActionSelected, ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import ServicesState from '../State/ServicesState'

const actionServicesFetchError = (oldState: ServicesState, action: Action): ServicesState => {
    return { ...oldState, error: (action as ActionServicesFetchError).message, loading: false }
}

const actionServicesFetchLoading = (oldState: ServicesState, _action: Action): ServicesState => {
    return { ...oldState, loading: true, error: undefined }
}

const actionServices = (oldState: ServicesState, action: Action): ServicesState => {
    return { ...oldState, loading: false, error: undefined, data: (action as ActionServices).list }
}
const actionServiceSelected = (oldState: ServicesState, action: Action): ServicesState => {
    return { ...oldState, selected: (action as ActionSelected).item }
}

type Process = (oldState: ServicesState, action: Action) => ServicesState

export const ServiceReducer: Reducer<ServicesState, Action> = (state: ServicesState = {
    data: [], loading: false, error: undefined, selected: undefined
}, action: Action): ServicesState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.SERVICE_LOADING, actionServicesFetchLoading)
    actionMap.set(ActionType.SERVICE_DATA, actionServices)
    actionMap.set(ActionType.SERVICE_ERROR, actionServicesFetchError)
    actionMap.set(ActionType.SERVICE_SELECTED, actionServiceSelected)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


